export class OrganizationTeamMemberDisplayStatuses {
  public static NOT_ACCEPTED = 'Not accepted'
  public static ACTIVE = 'Active'
  public static ARCHIVED = 'Archived'
  public static INVITATION_EXPIRED = 'Invitation Expired'
}

export type OrganizationTeamMemberStatus = 'NOT_ACCEPTED' | 'ACTIVE' | 'ARCHIVED' | 'INVITATION_EXPIRED'

export class OrganizationTeamMemberStatuses {
  public static NOT_ACCEPTED = 'NOT_ACCEPTED'
  public static ACTIVE = 'ACTIVE'
  public static ARCHIVED = 'ARCHIVED'
  public static INVITATION_EXPIRED = 'INVITATION_EXPIRED'
}



// WEBPACK FOOTER //
// ./src/constants/organization-team-member-statuses.ts